'use strict';


const directiveModule = angular.module('tdl.directives', ['tdl.config', 'tdl.filters', 'tdl.services']);

export default  directiveModule;
